module.exports = __webpack_public_path__ + "img/13.dd73a276.svg";